// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2iepX","name":"Header_name__3Y6Cb","birthday":"Header_birthday__3MkkD","skeleton":"Header_skeleton__vzSR0"};